import { useState } from "react";
import { useTranslation } from "react-i18next";

import Button, { ButtonProps } from "@/components/atoms/Button";
import Modal from "@/components/molecules/Modal";
import MapUnmatchedItemsModal from "@/components/molecules/modals/matching/MapUnmatchedItemsModal";

type UnmatchedCompaniesModalHandlerProps = {
  count: number;
  listId: string;
  alertIsShown: boolean;
  btnProps?: Omit<ButtonProps, "onClick" | "label">;
};

const UnmatchedCompaniesModalHandler = ({
  count,
  listId,
  alertIsShown,
  btnProps,
}: UnmatchedCompaniesModalHandlerProps) => {
  const { t } = useTranslation();
  const [isOpened, setIsOpened] = useState<boolean>(false);

  return (
    count > 0 && (
      <>
        <Button onClick={() => setIsOpened(true)} label={t("unmatched.map", { count: count })} {...btnProps} />

        <Modal
          isOpen={isOpened}
          size={"xl"}
          padding={"none"}
          onClose={() => setIsOpened(false)}
          content={MapUnmatchedItemsModal}
          contentProps={{
            listId,
            alertIsShown,
            onSuccess: () => setIsOpened(false),
            onClose: () => setIsOpened(false),
          }}
        />
      </>
    )
  );
};

export default UnmatchedCompaniesModalHandler;
